import types from '../types';
import { getURLValueFromActiveInputs } from '.';

const normalizeURLValue = value => value.toString();

/**
 * @param {types.Filter[]} filters
 * @returns {Object}
 */
const getURLParamsFromActiveFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return {};
    }

    return filters.reduce((acc, curr) => {
        let value = null;

        switch (curr.type) {
            case 'checkbox':
                value = getURLValueFromActiveInputs(curr.options);
                break;

            default:
                value = null;
                break;
        }

        // ignore parameter if there is no value
        if (value === null) {
            return acc;
        }

        return {
            ...acc,
            [curr.id]: normalizeURLValue(value)
        };
    }, {});
};

export default getURLParamsFromActiveFilters;
